import FoodCard from "../../../../components/foodCard";
import { IFood } from "../../../../components/foodCard/food.interface";

const CategorySection = ({ categoryId, categoryTitle, foods, refId }: any) => {
  return (
    <>
      <div
        ref={refId}
        className='border-t mt-2 mb-14'
      ></div>
      <div
        className=' pb-4'
        id={`category-${categoryId}`}
      >
        <div className='font-bold text-xl mt-4 mr-2 text-gray-500'>
          {categoryTitle}
        </div>
        <div>
          {foods.map((food: IFood) => (
            <FoodCard
              key={food.id}
              data={food}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default CategorySection;
